var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 86",
    style: {
      enableBackground: "new 0 0 43 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EA0B2A;}\n\t.st1{fill:none;stroke:#EA0B2A;stroke-width:3;stroke-linecap:round;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.1,
    cy: 70.2,
    r: 12.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1,70.2V3.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineUp);
export default __webpack_public_path__ + "static/media/TimelineUp.6c0312cf152d09a55399ae7002525a4d.svg";
export { ForwardRef as ReactComponent };